var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"main-container",attrs:{"id":"bid-paperwork","fluid":"","tag":"section"}},[_c('idc-component-bid-paperwork',{attrs:{"settings":_vm.settings,"can-edit":_vm.canEdit,"can-read":_vm.canRead,"can-delete":_vm.canDelete,"url-specification":_vm.urlSpecification}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }